import * as React from "react";
import { useMemo } from "react";
import { RichTextInput } from "ra-input-rich-text";
import {
    ArrayInput,
    AutocompleteInput,
    BooleanInput,
    Create,
    DateInput,
    FileField,
    FileInput,
    FormDataConsumer,
    maxValue,
    minValue,
    NumberInput,
    required,
    ReferenceInput,
    SaveButton,
    SelectInput,
    SimpleFormConfigurable,
    SimpleFormIterator,
    TextInput,
    Toolbar,
    useNotify,
    usePermissions,
    useRedirect,
    useCreate,
    useCreateSuggestionContext,
} from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";



export const RanCreate = () => (
    <Create>
        <SimpleFormConfigurable>
            <TextInput source="sName" />
            <DateInput source="created_at" />
        </SimpleFormConfigurable>
    </Create>
);

export default RanCreate;